import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IFavoriteParams } from '../../spacesPlatform/utils/actionParams';

export class RemoveFavoriteRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('removeFavorite', params);
  }
}
